import { AnalyticUiEvent, AnalyticPayload } from '../types';
import { Nullable } from '@/scripts/models/utility-types';

interface CustomEventPayload {
  type: string;
  data: Record<string, any>;
}

export interface UiEventPayload extends CustomEventPayload {
  type: 'ui_event';
  data: AnalyticUiEvent;
}

export type DomTrackerCallbackPayload = Nullable<AnalyticPayload | UiEventPayload>;

const convertToInt = (value: string | number): number => {
  if (typeof value === 'number') return value;
  const converted = parseInt(value, 10);
  if (`${converted}` !== value) {
    throw new Error(`Cannot convert ${value} to integer`);
  }
  return converted;
};
const convertToFloat = (value: string | number): number => {
  if (typeof value === 'number') return value;
  return parseFloat(value);
};

type ProcessAsUiEventDataParams = {
  eventAction?: string;
  eventSection?: string;
  eventResourceUri?: string;
  eventItemClass?: string;
  eventLabel?: string;
  eventValue?: string;
  eventOrder?: string;
  eventBlockReason?: string;
  eventParentUri?: string;
}

export const processAsUiEvent = (trackable: HTMLElement, dataset?: unknown): DomTrackerCallbackPayload => {
  if (typeof dataset !== 'object' || dataset == null) return null;

  if (!('eventAction' in dataset)) return null;

  const data: ProcessAsUiEventDataParams = dataset;

  if (typeof data.eventAction !== 'string') return null;

  try {
    // Map data from dataset to UiEventPayload
    return {
      type: 'ui_event',
      data: {
        action: data.eventAction,
        section: data.eventSection ?? trackable,
        resourceUri: data.eventResourceUri,
        itemClass: data.eventItemClass,
        label: data.eventLabel,
        value: data.eventValue == null ? null : convertToFloat(data.eventValue),
        order: data.eventOrder == null ? null : convertToInt(data.eventOrder),
        blockReason: data.eventBlockReason,
        parentUri: data.eventParentUri,
      },
    };
  } catch (error) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    if (process.env.NODE_ENV !== 'production') {
      throw error;
    }

    // eslint-disable-next-line no-console
    console.error(error.message);
    return null;
  }
};
